<template>
    <div class="img-item-box">
        <div class="img"><img :src="imgUrl"></div>
        <div class="two-text">
            <!-- <span class="text-one">{{num}}</span> -->
            <!-- <countTo :class="[type==1?'text-one-info':'text-one']" :startVal=0 :endVal='num' :duration='1000'></countTo> -->
            <span :class="[type==1?'text-one-info':'text-one']">{{num}}</span>
            <span :class="[type==1?'text-two-info':'text-two']">{{unit}}</span>
        </div>
        <div class="title-name">{{titleName}}</div>
    </div>
</template>

<script>
// import countTo from 'vue-count-to'
export default {
  // components: { countTo },
  props: {
    imgUrl: {
      type: String,
      default: require('../../assets/area.png')
    },
    num: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: '个'
    },
    titleName: {
      type: String,
      default: '名称'
    },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.img-item-box {
    width: 100%;
    height: 100%;
    .img {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 140px;
            // height: 140px;
        }
    }
    .two-text {
        display: flex;
        justify-content: center;
        align-items: baseline;
        color: #00fff6;
        line-height: 1;
        .text-one {
            font-size: 56px;
            font-weight: border;
        }
        .text-two {
            font-size: 30px;
            font-weight: normal;
        }
        .text-one-info {
            font-size: 56px;
            font-weight: border;
            color: #e00404;
        }
        .text-two-info {
            font-size: 30px;
            font-weight: normal;
            color: #e00404;
        }
    }
    .title-name {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        font-weight: normal;
    }
}
</style>
